export const exterior_view06ImageOptions = {
  angle: 'exterior_view06',
  staticOptions: {
    BowSprit: 1,
    HullTreatment: 1,
    Deck: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    SolarPanels: 1,
    DavidsRib: 1,
    RemovableGangway: 1,
    MastAndBoom: 1,
    SprayHood: 1,
    BoomCover: 1,
    Boom: 1
  },
  mattes: [
    {
      option: 'TeakOnSideDecks',
      dependency: 'Deck'
    },
    {
      option: 'DavidsRib',
      dependency: null
    },
    {
      option: 'MastAndBoom',
      dependency: null
    },
    {
      option: 'SprayHood',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/Xc47/views/exterior_view06.js